<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:m-0 m-4">
      <vx-card class="radius-25">
        <div slot="no-body">

          <vs-input type="hidden" ref="enter" @keyup.enter="login"></vs-input>
          <div class="vx-row no-gutter justify-center items-center radius-25">

            <div class="vx-row lg:block w-full  login-header">
              <logo class="mx-auto fill-current text-secondary" />
            </div>

            <div class="vx-row w-full d-theme-dark-bg">

              <div class="lg:p-8 sm:p-4 p-4 login-tabs-container w-full">

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4 text-primary text-center">Verifying mail</h4>
                </div>
              </div>

            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Logo from '../../layouts/components/Logo.vue'

export default{
  props: {
    token: {
      type: String
    }
  },
  components: {
    Logo
  },
  data () {
    return {
    }
  },
  methods: {
    login () {
      if (this.token) {
        const payload = {
          token: this.token
        }
        this.$store.dispatch('api/verifyMail', payload)
          .then(() => {
            this.$vs.loading.close()
            this.$vs.notify({
              title: 'E-mail verified',
              text: 'Redirecting to home',
              iconPack: 'feather',
              icon: 'icon-check',
              color: 'success'
            })
            this.$router.push('/')
          })
          .catch(() => {
            this.$vs.loading.close()
          })
      } else {
        this.$vs.notify({
          title: 'Error',
          text: 'Email token could not be found',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }

    }
  },
  mounted () {
    this.login()
  }
}
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook { background-color: #1551b1 }
    .bg-twitter { background-color: #00aaff }
    .bg-google { background-color: #4285F4 }
    .bg-github { background-color: #333 }
  }
  .login-header {
    text-align: center;
    padding: 1rem;
    justify-content: center;
  }
  .vx-card {
    overflow:hidden;
  }
  .vx-logo-text {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
